var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,{tag:"component",attrs:{"type":_vm.iconType,"image":_vm.imagePath}})}
var staticRenderFns = []

export { render, staticRenderFns }